import React, { useState } from 'react';
import { X, Camera, Type, Image, Video } from 'lucide-react';

const StatusPoster = ({ onClose, onPost }) => {
  const [mediaType, setMediaType] = useState('text');
  const [text, setText] = useState('');
  const [caption, setCaption] = useState('');
  const [bgColor, setBgColor] = useState('#075e54');
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);

  const handleFileChange = (e) => {
    const f = e.target.files[0];
    if (f) {
      setFile(f);
      setPreview(URL.createObjectURL(f));
      if (f.type.startsWith('image/')) setMediaType('image');
      else if (f.type.startsWith('video/')) setMediaType('video');
    }
  };

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append('mediaType', mediaType);
    if (mediaType === 'text') {
      formData.append('text', text);
      formData.append('bgColor', bgColor);
    } else {
      formData.append('mediaFile', file);
      if (caption) formData.append('caption', caption);
    }
    onPost(formData);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md mx-4 p-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">New Status</h3>
          <button onClick={onClose} className="text-gray-500"><X size={20} /></button>
        </div>

        <div className="flex gap-2 mb-4">
          {['text', 'image', 'video'].map(t => (
            <button key={t} onClick={() => setMediaType(t)} className={`flex items-center gap-1 px-3 py-1 rounded-full text-sm ${mediaType === t ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'}`}>
              {t === 'text' && <Type size={14} />}
              {t === 'image' && <Image size={14} />}
              {t === 'video' && <Video size={14} />}
              {t.charAt(0).toUpperCase() + t.slice(1)}
            </button>
          ))}
        </div>

        {mediaType === 'text' ? (
          <>
            <textarea placeholder="Type a status..." value={text} onChange={(e) => setText(e.target.value)} className="w-full p-3 border rounded-md text-sm mb-2" rows={3} />
            <div className="flex items-center gap-2">
              <input type="color" value={bgColor} onChange={(e) => setBgColor(e.target.value)} className="w-8 h-8 rounded cursor-pointer" />
              <span className="text-xs text-gray-500">Background</span>
            </div>
          </>
        ) : (
          <div className="mb-4">
            <label className="block w-full cursor-pointer border-2 border-dashed border-gray-300 rounded-lg p-4 text-center text-gray-500 hover:border-green-400">
              {preview ? <img src={preview} alt="preview" className="max-h-40 mx-auto rounded" /> : (
                <>
                  <Camera size={32} className="mx-auto mb-1" />
                  <span className="text-sm">Tap to choose {mediaType}</span>
                </>
              )}
              <input type="file" accept={mediaType === 'image' ? 'image/*' : 'video/*'} onChange={handleFileChange} className="hidden" />
            </label>
            {file && <input type="text" placeholder="Caption..." value={caption} onChange={(e) => setCaption(e.target.value)} className="w-full mt-2 p-2 border rounded-md text-sm" />}
          </div>
        )}

        <div className="flex justify-end gap-2 mt-4">
          <button onClick={onClose} className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-md text-sm">Cancel</button>
          <button onClick={handleSubmit} disabled={mediaType === 'text' && !text.trim() || mediaType !== 'text' && !file} className="px-4 py-2 bg-green-600 text-white rounded-md text-sm font-semibold hover:bg-green-700 disabled:opacity-50">Post</button>
        </div>
      </div>
    </div>
  );
};

export default StatusPoster;